module.exports = __webpack_public_path__ + "static/media/g.a5ed2da8.jpg";